export default {

	createScale(options) {

		let interval = Math.ceil(options.scale / 10000) * 100
		let desiredMeters = interval / options.scale
		let nbrPixels1km = desiredMeters / 0.0002654867257
		
		let height = 80
		let width = Math.round((nbrPixels1km * 4) + 50)

		var rect = new fabric.Rect({
			width: width,
			height: height,
			fill: 'white',
			stroke: 'black',
			strokeWidth: 1,
			rx: 3,
			ry: 3,
		});

		let title = this.addTitle(width / 2, options.scale)
		let scale = this.addScale(interval, nbrPixels1km)
		let meterTitle = this.addMeterLabel(width / 2)

		let left = options.left ? options.left : options.pageWidth - width - 20
		let top = options.top ? options.top : options.pageHeight - height - 20

		var group = new fabric.Group([rect, title, scale, meterTitle], {
			type: 'scale',
			left: left,
			top: top,
			hasControls: false,
		});

		return group
	},

	/**
	 * Adds the scale title
	 */
	addTitle(center, scale) {
		return new fabric.Text("Skala 1:" + scale, {
			originX: 'center',
			left: center,
			top: 5,
			fontSize: 15,
			fontFamily: 'Helvetica'
		});
	},

	addScale(interval, nbrPixels1km) {

		let textGroup = this.addTexts(interval, nbrPixels1km)
		let lineGroup = this.addLines(nbrPixels1km)

		return new fabric.Group([textGroup, lineGroup], {
			top: 35,
			left: 25,
		})
	},

	
	addTexts(interval, nbrPixels1km) {
		let texts = []
		let textCoords = []

		for (let i = 0; i < 5; i++) {
			textCoords[i] = nbrPixels1km * i
		}
		
		let value = 0
		textCoords.forEach((coord, i) => {
			value = i * interval
			texts.push(new fabric.Text(value.toString(), {
				originX: 'center',
				left: coord,
				fontSize: 12,
				fontFamily: 'Helvetica'
			}))
		});

		return new fabric.Group(texts)
	},

	addLines(nbrPixels1km) {
		let lines = []
		let lineCoords = [
			[0,		0, 	0, 	  10],

			[0,		10,	null, 10],
			[null, 	5,	null, 11],

			[0, 	10,	null, 10],
			[null, 	5,	null, 11],

			[0, 	10,	null, 10],
			[null, 	5,	null, 11],

			[0, 	10,	null, 10],
			[null, 	0,	null, 11],
		]

		let currentValue = nbrPixels1km

		for (let i = 1; i < lineCoords.length; i += 2) {
			
			lineCoords[i][2] = currentValue
			lineCoords[i + 1][0] = currentValue
			lineCoords[i + 1][2] = currentValue

			currentValue += nbrPixels1km
		}

		lineCoords.forEach(coord => {
			lines.push(new fabric.Line(coord, {
				fill: 'black',
				stroke: 'black',
				strokeWidth: 1,
			}))
		});

		return new fabric.Group(lines, {
			top: 15,
		})
	},

	addMeterLabel(center) {
		return new fabric.Text("meter", {
			originX: 'center',
			left: center + 2,
			top: 60,
			fontSize: 15,
			fontFamily: 'Helvetica'
		});
	}

}